const appConfig = {
  appName: 'Uhamiaji SACCOS CMS',
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  apiBaseUrlCms: process.env.REACT_APP_API_BASE_URL_CMS || process.env.REACT_APP_API_BASE_URL,
  defaultLanguage: 'en',
  itemsPerPage: 10,
  supportedLanguages: ['en', 'sw'],
};

export default appConfig;
